
<router-outlet></router-outlet>
<p-toast position="top-right"></p-toast>
<div class="app-loader" *ngIf="showLoader || showLoader1">
    <mat-spinner [diameter]="50" [strokeWidth]="8"></mat-spinner>
</div>

<p-dialog
  header="Open App"
  [(visible)]="showAppPrompt"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [style]="{ width: '90vw', maxWidth: '350px' }"
  [breakpoints]="{ '960px': '95vw' }">

  <p class="info" style="    font-size: 14px;padding: 10px 0;">
    Do you want to continue in the app or stay on the website?
  </p>

  <div class="dialog-actions">
    <button
      type="button"
      class="btn reset-btn btn-cancel mr-10"
      (click)="continueOnWeb()">Continue on Web
    </button>

    <button
      type="button"
      class="btn btn-primary"
      (click)="openInApp()">Open in App
    </button>
  </div>
</p-dialog>